// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";
import { useSelector } from "react-redux";

import { getCurrentUserId } from "src/reducers";
import Name from "src/components/Form/Name";
import GenericNotification from "src/components/messages/Chat/Notification/Generic";
import * as notifications from "src/constants/notifications";

import type { Message } from "src/types";

type Props = {
  message: Message,
  groupPosition?: string,
  notification: string,
};

const AddRemoveForm = ({ message, groupPosition, notification }: Props) => {
  const templateId = message?.data?.templateId;
  const currentUser = useSelector(({ app }) => getCurrentUserId(app));
  const actionText =
    notification === notifications.FORM_ADD ? "ADDED_A_FORM" : "REMOVED_A_FORM";
  const endText =
    notification === notifications.FORM_ADD
      ? "TO_THE_CHECKLIST"
      : "FROM_THE_CHECKLIST1";
  return (
    <GenericNotification
      message={message}
      isCurrentUser={currentUser === message.author}
      first={groupPosition === "first"}
    >
      <span>
        {i18n.t(k[`${actionText}`])}{" "}
        <strong>
          <Name id={templateId} />
        </strong>{" "}
        {i18n.t(k[`${endText}`])}
      </span>
    </GenericNotification>
  );
};

export default AddRemoveForm;
